<div class="page-container">
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon" aria-hidden="true">percent</mat-icon>
      <div>
        <h1 class="page-title">Interest Rates</h1>
        <p class="page-description">Configure interest rates applied to delinquent Tourist Development Tax accounts.</p>
      </div>
    </div>
    <button mat-flat-button color="primary" class="add-button" (click)="addRate()" aria-label="Add new interest rate">
      <mat-icon>add</mat-icon>
      ADD RATE
    </button>
  </div>

  <div class="mat-elevation-z2 table-card" role="region" aria-label="Interest rates table">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Interest rates list">

      <ng-container matColumnDef="effectiveDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Effective Date</th>
        <td mat-cell *matCellDef="let row">{{ row.effectiveDate | date }}</td>
      </ng-container>

      <ng-container matColumnDef="rate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rate (%)</th>
        <td mat-cell *matCellDef="let row">{{ row.rate | number:'1.1-2' }}%</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="row.status === 'ACTIVE' || row.status === 'Active' ? 'status-active' : 'status-inactive'"
                role="status" [attr.aria-label]="'Status: ' + row.status">
            {{ row.status }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="editRate(row); $event.stopPropagation()"
                  [attr.aria-label]="'Edit rate ' + row.rate + '%'">
            <mat-icon class="action-icon edit-icon">edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteRate(row); $event.stopPropagation()"
                  [attr.aria-label]="'Delete rate ' + row.rate + '%'">
            <mat-icon class="action-icon delete-icon">delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No interest rates found.</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page"></mat-paginator>
  </div>
</div>
